import axios from "axios";
const http = axios.create({
  baseURL: "/api/",
  timeout: 1000 * 60,
  headers: {
    "Content-Type": "application/json"
  }
});
// 请求拦截器
http.interceptors.request.use(
  config => {
    return config
  },
  err => {
    Promise.reject(err);
  }
);

//响应拦截器
http.interceptors.response.use(
  res => {
    if (res.status === 200 && res.data) {
      return res.data;
    } else {
      return res;
    }
  },
  err => {
    return err.response.status
   }
);

export default http

